import {takeEvery} from 'redux-saga';
import http from '../_utils/httpSaga';
import {toastr} from 'react-redux-toastr';
import {put} from 'redux-saga/effects';

import {
  LOGIN,
  LOGOUT,
  MODIFY_API_TOKEN,
  loginSuccess,
  loginFailure,
  modifyApiTokenSuccess,
  modifyApiTokenFailure
} from './actions';


function* fetchUser({username}) {
  let result = yield http.json.get(`/api/checkToken?api_token=${username}`);
  if (result instanceof Error) {
    toastr.error('Echec de l\'authentification');
    try {
      sessionStorage.setItem('safariTest', 'ok');
      sessionStorage.removeItem('token');
    } catch(e) {
      window.STORAGE_TOKEN = undefined;
    }

    yield put(loginFailure(result));
  } else {
    try {
      sessionStorage.setItem('safariTest', 'ok');
      sessionStorage.setItem('token', username);
    } catch(e) {
      window.STORAGE_TOKEN = username;
    }
    yield put(loginSuccess((result)));
  }
}

function* logoutUser() {
    try {
      sessionStorage.setItem('safariTest', 'ok');
      sessionStorage.removeItem('token');
    } catch(e) {
      window.STORAGE_TOKEN = undefined;
    }
}

function* modifyApiToken({userId, newToken, oldToken}) {
  const payload = {
    password_update: true,
    current_token: oldToken,
    user: {
      api_token: newToken
    }
  };
  let result = yield http.json.put(`/api/user/${userId}`, payload);
  if (result instanceof Error) {
    yield put(modifyApiTokenFailure(result));
  } else {
    yield put(modifyApiTokenSuccess(newToken));
  }
}

function* updateLocalApiToken({newToken}) {
  toastr.success('Votre code d\'accès a bien été modifié');
  try {
      sessionStorage.setItem('safariTest', 'ok');
      sessionStorage.setItem('token', newToken);
  } catch(e) {
      window.STORAGE_TOKEN = newToken;
  }
}

function* showErrorMessage() {
  toastr.error('Une erreur a eu lieu lors de la modification de votre code d\'accès');
}

export default function*() {
  yield [
    takeEvery(LOGIN.do, fetchUser),
    takeEvery(LOGOUT, logoutUser),
    takeEvery(MODIFY_API_TOKEN.do, modifyApiToken),
    takeEvery(MODIFY_API_TOKEN.success, updateLocalApiToken),
    takeEvery(MODIFY_API_TOKEN.failure, showErrorMessage)
  ];
}



// WEBPACK FOOTER //
// ./src/redux/user/saga.js